(() => {
  if (window.__tbarReady) return;
  window.__tbarReady = true;

  // Mobile : une seule info visible, qui change toutes les X secondes
  const mq = window.matchMedia('(max-width: 749px)');

  const init = (bar) => {
    if (!bar || bar.__tbar) return;
    const items = Array.from(bar.querySelectorAll('.tbar__item'));
    if (items.length < 2) return;
    bar.__tbar = true;
    let i = Math.max(0, items.findIndex((el) => el.classList.contains('is-active')));
    const ms = Math.max(1, Number(bar.dataset.interval) || 2) * 1000;
    const timer = setInterval(() => {
      if (!bar.isConnected) {
        clearInterval(timer);
        return;
      }
      if (!mq.matches || document.hidden) return;
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, ms);
  };

  const initAll = (scope) => (scope || document).querySelectorAll('[data-tbar]').forEach(init);
  document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  document.addEventListener('shopify:block:select', (e) => {
    const item = e.target instanceof Element ? e.target.closest('.tbar__item') : null;
    if (!item) return;
    item.closest('[data-tbar]').querySelectorAll('.tbar__item').forEach((el) => {
      el.classList.toggle('is-active', el === item);
    });
  });
  initAll();
})();